module.exports = __webpack_public_path__ + "app-static/img/12.de97d3d7.png";